export interface SelectCompanyModel {
  company?: string
  region?: string
}

export interface DivisionState {
  divisions: DivisionModel[]
  regions: DropDownItem[]
  selectCompany: SelectCompanyModel
  selectedDivision: string
  selectedRows: number
  currentPage: number
}

export const GET_ALL_DIVISION = 'GET_ALL_DIVISION'
export const GET_ALL_REGION = 'GET_ALL_REGION'
export const SCAN_ALL_DIVISION = 'SCAN_ALL_DIVISION'
export const SELECT_COMPANY = 'SELECT_COMPANY'
export const SELECTED_DIVISION = 'SELECTED_DIVISION'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_SELECTED_ROWS = 'SET_SELECTED_ROWS'
